const initialState = { orders: [], allorders: [] };

export const ordersReducer = (state = initialState, action) => {
  switch (action.type) {

    case "GET_ORDERS":
      return {
        ...state,
        orders: Array.isArray(action.payload) ? action.payload : []
      };

    case "GET_LISTS_ORDERS":
      return {
        ...state,
        allorders: Array.isArray(action.payload) ? action.payload : []
      };

    case "ADD_ORDERS":
      return {
        ...state,
        orders: [...state.orders, action.payload]
      };

    case "UPDATE_ORDER":
      return {
        ...state,
        orders: state.orders.map(o =>
          o.id === action.payload.id ? action.payload : o
        ),
        allorders: state.allorders.map(o =>
          o.id === action.payload.id ? action.payload : o
        )
      };

    case "UPLOAD_PAYMENT_SS_SUCCESS":
      return {
        ...state,
        orders: state.orders.map(o =>
          o.id === action.payload.id ? action.payload : o
        ),
        allorders: state.allorders.map(o =>
          o.id === action.payload.id ? action.payload : o
        )
      };

    case "REVIEW_SUBMITTED_SUCCESS":
      return {
        ...state,
        orders: state.orders.map(o =>
          o.id === action.payload.id ? action.payload : o
        ),
        allorders: state.allorders.map(o =>
          o.id === action.payload.id ? action.payload : o
        )
      };

    case "DELETE_ORDERS":
      return {
        ...state,
        orders: state.orders.filter(o => o.id !== action.payload)
      };

    default:
      return state;
  }
};
